<template>
  <div class="px-4 sm:px-6 py-5 space-y-8">
    <TrackingLogList
      :email-campaign="emailCampaign"
      :default-query-params="options.defaultQueryParams"
    />
  </div>
</template>

<script>
import TrackingLogList from './TrackingLogList.vue';

export default {
  components: {
    TrackingLogList,
  },
  props: {
    emailCampaign: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
